import React from "react";

const ExportIcon = ({ size, className, strokeWidth = "1.5" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth={strokeWidth}
          d="M8 1.333A6.67 6.67 0 001.333 8 6.669 6.669 0 008 14.667 6.669 6.669 0 0014.666 8"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
          d="M8.667 7.333l5.467-5.466M14.666 4.553v-3.22h-3.22"
        />
      </svg>
    </span>
  );
};

export const ExportSecondaryIcon = ({
  size = 16,
  className = "text-black",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          d="m8.668 7.333 5.467-5.466m.53 2.666v-3.2h-3.2m-4.133 0H5.999C2.665 1.333 1.332 2.667 1.332 6v4c0 3.333 1.333 4.667 4.667 4.667h4c3.333 0 4.666-1.334 4.666-4.667V8.667"
        />
      </svg>
    </span>
  );
};

export default ExportIcon;
